/**
 * Utility for session storage
 *
 * @author John Lukose <john.lukose@quikr.com>
 */
import root from 'window-or-global';


let sessionStorageWrapper = null;

class SessionStorageWrapper {
  constructor() {
    if (sessionStorageWrapper) {
      return sessionStorageWrapper;
    }

    sessionStorageWrapper = this;
  }

  get(key) {
    return root.sessionStorage && root.sessionStorage.getItem(key);
  }

  set(key, value) {
    try {
      root.sessionStorage && root.sessionStorage.setItem(key, value);
      return true;
    } catch (e) {
      // console.error('Session Storage : error while set item ' + e + key + value);
      return false;
    }
  }

  remove(key) {
    root.sessionStorage && root.sessionStorage.removeItem(key);
  }
}

sessionStorageWrapper = new SessionStorageWrapper();
export default sessionStorageWrapper;



// WEBPACK FOOTER //
// ../q-jobs/src/utils/WebStorageWrapper/sessionStorageWrapper.js